import httpClient from "../api/httpClient";

export const acceptSuggestedImages = async (payload) => {
  const endpoint = "/refsuggestion/accept";
  return httpClient.put(endpoint, payload);
};

export const deleteSuggestedImages = async (payload) => {
  const endpoint = "/refsuggestion/delete";
  return httpClient.delete(endpoint, {data: payload});
};

export const getSuggestedImages = async (payload) => {
  const endpoint = `refsuggestion/${payload}/getall`;
  return httpClient.get(endpoint);
};

export const getSuggestedImageByUser = async (payload) => {
  const endpoint = `refsuggestion/${payload.deceasedId}/get/${payload.userId}`;
  return httpClient.get(endpoint);
};

export default {
  acceptSuggestedImages,
  deleteSuggestedImages,
  getSuggestedImages,
  getSuggestedImageByUser
};
